import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import { initializePerformanceTracking } from './utils/performance'
import { initializeNotiflix } from './utils/notiflix'
import { notificationSchedulerService } from './services/NotificationSchedulerService'
import { lineConfigLoader } from './services/LineConfigLoader'
import { roleDirective, adminDirective } from './directives/permission'

const app = createApp(App)

app.use(createPinia())
app.use(router)

// Register role-based directives
app.directive('role', roleDirective)
app.directive('admin', adminDirective)

// Initialize Notiflix
initializeNotiflix()

// Initialize performance monitoring
if (import.meta.env.PROD) {
  initializePerformanceTracking()
}

// Initialize LINE configuration from database
console.log('📡 [INIT] Loading LINE config from database...')
lineConfigLoader.loadConfig()
  .then(config => {
    console.log('✅ [INIT] LINE config loaded:', { enabled: config.enabled, hasToken: !!config.channelAccessToken })

    // Initialize notification scheduler if enabled
    if (config.enabled && config.channelAccessToken) {
      console.log('🔔 [INIT] Starting notification scheduler...')
      notificationSchedulerService.start()
      console.log('🔔 [INIT] Notification scheduler started')
    } else {
      console.log('🔔 [INIT] LINE notifications are disabled or not configured, skipping scheduler start')
    }
  })
  .catch(error => {
    console.error('❌ [INIT] Failed to load LINE config:', error)
  })

app.mount('#app')